module.exports = [
	'Level 1',
	'Level 2',
	'Level 3',
];


//////////////////
// WEBPACK FOOTER
// ../server/constants/foodSafetyCertificateLevels.js
// module id = 1191
// module chunks = 0